<template>
  <div class="items-content">
    <div class="tabs-container p-3">
      <left-tabs :tabs="tabs" menu="tipo" class="modern-tabs">
        <template #medicines>
          <Medicines />
        </template>
        <template #products>
          <Products />
        </template>
        <template #lots>
          <Lots />
        </template>
      </left-tabs>
    </div>

    <!-- Migration Actions (if applicable) -->
    <div
      v-if="
        $route.query.migrate ||
        $route.query.delete_lots_without_owner ||
        $route.query.update_lots_medicine
      "
      class="migration-section"
    >
      <div class="migration-card">
        <div class="migration-header">
          <h3 class="migration-title">
            <i class="fas fa-cogs mr-2"></i>
            Ações de Migração
          </h3>
        </div>
        <div class="migration-content">
          <div class="migration-actions">
            <v-btn
              v-if="$route.query.migrate"
              :disabled="loadingExecuteMedicineProduct"
              @click="executeMedicineProduct"
              class="migration-btn primary-btn"
            >
              <i class="fas fa-play mr-2"></i>
              {{
                loadingExecuteMedicineProduct
                  ? "Executando..."
                  : "Executar medicamentos/produtos"
              }}
            </v-btn>

            <v-btn
              v-if="$route.query.delete_lots_without_owner"
              @click="deleteLotsWithoutOwner"
              class="migration-btn warning-btn"
            >
              <i class="fas fa-trash mr-2"></i>
              Deletar lotes sem dono
            </v-btn>

            <v-btn
              v-if="$route.query.update_lots_medicine"
              @click="updateLotsMedicine"
              class="migration-btn info-btn"
            >
              <i class="fas fa-sync mr-2"></i>
              Atualizar lotes de medicamentos
            </v-btn>
          </div>

          <ErrorsMessages :errors="errors" v-if="errors.length > 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTabs from "../Components/LeftTabs.vue";
import Products from "./items/products.vue";
import Medicines from "./items/medicines.vue";
import Lots from "./items/lots.vue";

import ErrorsMessages from "../Components/ErrorsMessages.vue";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import permission from "../../lib/permission";

export default {
  name: "Items",

  components: {
    LeftTabs,
    Products,
    Medicines,
    Lots,
    ErrorsMessages,
  },

  data() {
    return {
      tabs: [],

      errors: [],
      loadingExecuteMedicineProduct: false,
    };
  },

  created() {
    let tabs = [];

    if (permission("read", "medicine")) {
      tabs.push({ title: "MEDICAMENTOS", step: "medicines" });
    }

    if (permission("read", "product")) {
      tabs.push({ title: "PRODUTOS", step: "products" });
    }

    tabs.push({ title: "LOTES", step: "lots" });

    this.tabs = tabs;
  },

  methods: {
    permission,

    async executeMedicineProduct() {
      try {
        this.loadingExecuteMedicineProduct = true;
        let response = await api.post("/rest-home/execute-medicine-product");

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }
        this.loadingExecuteMedicineProduct = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteLotsWithoutOwner() {
      try {
        let response = await api.post(
          "/rest-home/execute-delete-lot-without-owner"
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateLotsMedicine() {
      try {
        let response = await api.post(
          "/rest-home/execute-update-lots-medicine"
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.items-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.items-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.items-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

/* Content Section */
.items-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

.tabs-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

/* Migration Section */
.migration-section {
  margin-bottom: 32px;
}

.migration-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.migration-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #f59e0b;
}

.migration-title {
  font-size: 18px;
  font-weight: 600;
  color: #92400e;
  margin: 0;
  display: flex;
  align-items: center;
}

.migration-content {
  padding: 24px;
}

.migration-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.migration-btn {
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.migration-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
}

.migration-btn:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.primary-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
}

.warning-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
}

.info-btn {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%) !important;
  color: white !important;
  border: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .items-container {
    padding: 0 16px;
  }

  .items-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .items-content {
    gap: 20px;
  }

  .migration-content {
    padding: 16px;
  }

  .migration-actions {
    flex-direction: column;
    gap: 12px;
  }

  .migration-btn {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .title-icon {
    font-size: 20px;
  }

  .migration-header {
    padding: 16px;
  }

  .migration-title {
    font-size: 16px;
  }
}

/* Override LeftTabs styling */
.modern-tabs >>> .nav-tabs {
  background: #f8fafc !important;
  border: none !important;
  padding: 0 24px !important;
}

.modern-tabs >>> .nav-link {
  background: transparent !important;
  border: none !important;
  color: #64748b !important;
  font-weight: 600 !important;
  padding: 16px 24px !important;
  margin: 0 8px !important;
  border-radius: 8px 8px 0 0 !important;
  transition: all 0.3s ease !important;
}

.modern-tabs >>> .nav-link:hover {
  background: rgba(15, 101, 176, 0.1) !important;
  color: #0f65b0 !important;
}

.modern-tabs >>> .nav-link.active {
  background: white !important;
  color: #0f65b0 !important;
  border-bottom: 2px solid #0f65b0 !important;
}

.modern-tabs >>> .tab-content {
  padding: 24px !important;
}
</style>